
import firebase from "firebase";

const firebaseConfig = {
  apiKey: "AIzaSyC6xqpXQUw_LpkDzmgNe9dPlttxL_74jns",
  authDomain: "midterm-em.firebaseapp.com",
  projectId: "midterm-em",
  storageBucket: "midterm-em.appspot.com",
  messagingSenderId: "54001412520",
  appId: "1:54001412520:web:8dbd1a0c25077bf588559d",
  measurementId: "G-J2701LJYXM"
};


firebase.initializeApp(firebaseConfig);
const db = firebase.firestore();
export {db}
export default firebase;